import { render, staticRenderFns } from "./IdenticonImage.vue?vue&type=template&id=5060dd42&"
import script from "./IdenticonImage.vue?vue&type=script&lang=js&"
export * from "./IdenticonImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports